<template>
  <div>
    <p>身長1：<input :height="info.height"></p>
    <p>体重2：<input :weight="info.weight"></p>
    <p>身長2：<input v-model="info.height"></p>
    <p>体重2：<input v-model="info.weight"></p>

    <!--結果領域-->
    <div>

    </div>
    <div>
      <p>結果</p>
    <router-com-child :height="info.height" :weight="info.weight"></router-com-child>

      
    </div>
  </div>
</template>
<script>
import RouterComChild from './RouterComChild.vue'
export default {
  components:{
    RouterComChild
  },
  data(){
    return{
      info:{
        height:0,
        weight:0
      }
    }
  }
}
</script>
<style scoped>

</style>